import api from '@/api'

export default {
  namespaced: true,
  state: {},
  getters: {},
  actions: {
    getHealthStatus() {
      return api.base()
        .get('/monitoring/health-status')
        .then(response => response.data.data)
    },
  },
}
